<template>
  <div class="page_">
    <div class="close" @click="close">X</div>
    <div v-html="content" class="content"></div>
  </div>
</template>

<style lang="scss" scoped>
.page_ {
  width: 100%;
  overflow: auto;
  .close {
    text-align: right;
    height: 30px;
    line-height: 30px;
    font-size: 20px;
  }
  ::v-deep .content {
    text-align: left;
    line-height: 42px;
    img {
      max-width: 100% !important;
    }
  }
}
</style>

<script>
export default {
  data() {
   return {
     content: ''
   } 
  },
  created() {
    this.content = this.$route.params.content
    console.log(this.$route.params);
  },
  methods: {
    close() {
      this.$router.go(-1)
    }
  }
}
</script>

